<template>
    <v-dialog
        v-model="dialogOpen"
        max-width="500"
        persistent
    >
        <v-card>

            <v-toolbar dense dark :color="toolbarColor">
                <v-toolbar-title class="white--text">{{ headline }}</v-toolbar-title>
            </v-toolbar>

            <v-card-text class="mt-2 mb-2 text-center">
                <v-icon size="70" color="yellow darken-2">mdi-alert</v-icon>
                <v-spacer></v-spacer>
                <span class="text-md-center">
                    {{ description }}
                    <slot></slot>
                </span>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                       :color="deleteButtonColor"
                       @click="confirmClicked"
                >
                    {{ confirmButtonText }}
                </v-btn>

                <v-btn
                    text
                    @click="abortClicked"
                >
                    {{ abortButtonText }}
                </v-btn>

            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default {

    props: {
        value: {
            type: Boolean,
            default: false,
            required: true
        },
        headline: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: false,
        },
        confirmButtonText: {
            type: String,
            required: false,
            default: 'Confirm',
        },
        abortButtonText: {
            type: String,
            required: false,
            default: 'Abort'
        },
        delete: {
            type: Boolean,
            required: false,
            default: false,
        }
    },

    data() {
        return {
            dialog: false
        }
    },
    computed: {
        dialogOpen: {
            get() {
                return this.value;
            },
            set() {
                this.closeDialog();
            }
        },
        toolbarColor() {
            return this.delete ? 'red darken-2' : 'primary';
        },
        deleteButtonColor() {
            return this.delete ? 'red darken-2' : 'primary';
        }
    },

    methods: {

        closeDialog() {
            this.$emit('input', false);
        },

        confirmClicked() {
            this.$emit('input', false);
            this.$emit('selected', true);
        },

        abortClicked() {
            this.$emit('input', false);
            this.$emit('selected', false);
        }
    }
}
</script>
